import { ENVIRONMENT } from "../../../environments/environment";
import { ICardinalEnvironmentConfig } from "./ICardinalEnvironmentConfig";

export class CardinalConfigFactory {
  static getConfig(): ICardinalEnvironmentConfig {
    return {
      v1: {
        live: ENVIRONMENT.CARDINAL_COMMERCE.V1_SONGBIRD_LIVE_URL,
        test: ENVIRONMENT.CARDINAL_COMMERCE.V1_SONGBIRD_TEST_URL,
      },
      v2: {
        live: {
          url: ENVIRONMENT.CARDINAL_COMMERCE.V2_SONGBIRD_LIVE_URL,
          sri: ENVIRONMENT.CARDINAL_COMMERCE.V2_SONGBIRD_LIVE_URL_SRI,
        },
        test: {
          url: ENVIRONMENT.CARDINAL_COMMERCE.V2_SONGBIRD_TEST_URL,
          sri: ENVIRONMENT.CARDINAL_COMMERCE.V2_SONGBIRD_TEST_URL_SRI,
        },
      },
      songbirdDomains: ENVIRONMENT.CARDINAL_COMMERCE.SONGBIRD_DOMAINS,
      connectivityTimeout: 5000,
    };
  }
}
